import {
  IPlatformBlock,
  IPlatformBlockPayload,
  IPlatformResourceResponse,
  IPlatformResourcesResponse
} from 'types/platformResources';
import request from './index';

export const getPlatformBlocks = () =>
  request<IPlatformResourcesResponse<IPlatformBlock>>({
    options: { url: '/platform/resources/blocks', method: 'get' }
  });

export const getPlatformBlock = (id: number) =>
  request<IPlatformResourceResponse<IPlatformBlock>>({
    options: { url: `/platform/resources/blocks/${id}`, method: 'get' }
  });

export const createPlatformBlock = (data: IPlatformBlockPayload) =>
  request<IPlatformResourceResponse<IPlatformBlock>>({
    options: { url: '/platform/resources/blocks', method: 'post', data }
  });

export const editPlatformBlock = (id: number, data: IPlatformBlockPayload) =>
  request<IPlatformResourceResponse<IPlatformBlock>>({
    options: { url: `/platform/resources/blocks/${id}`, method: 'patch', data }
  });

export const deletePlatformBlock = (id: number) =>
  request<Record<string, never>>({
    options: { url: `/platform/resources/blocks/${id}`, method: 'delete' }
  });
